export default {"src":"/_next/static/media/disc-types.d01daf64.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};